import './Link.scss'

import React from 'react'
import PropTypes from 'prop-types'

const Link = props => {
  const { href, title, children, className, target } = props
  const linkClasses = `${className} dtb-link`

  return <a className={linkClasses} target={target} href={href} title={title}>{children}</a>
}

Link.defaultProps = {
  className: '',
  title: '',
  target: '_self',
}

Link.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string,
  target: PropTypes.string,
  children: PropTypes.node,
}

export default Link



// WEBPACK FOOTER //
// ./src/components/Link/Link.js